import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  Chip,
  makeStyles,
  colors
} from '@material-ui/core';

import NavItem from './NavItem';

import { RiAlarmWarningLine } from "react-icons/ri";
import { Activity } from 'react-feather';
import { BsPinAngleFill } from "react-icons/bs";
import { MdManageAccounts } from "react-icons/md";
import { MdEngineering } from "react-icons/md";
import { RiArchiveLine } from "react-icons/ri";
import { GiHandTruck } from "react-icons/gi";
import { AiOutlineSchedule } from "react-icons/ai";
import { MdWaterfallChart } from "react-icons/md";

const items = [
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'AST'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'AST'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'MAN'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'AAD'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/agendas',
    icon: AiOutlineSchedule,
    title: 'Agenda',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/timeline',
    icon: MdWaterfallChart,
    title: 'Cronograma',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/partitions',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/agendas',
    icon: AiOutlineSchedule,
    title: 'Agenda',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/timeline',
    icon: MdWaterfallChart,
    title: 'Cronograma',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/partitions',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
      setUser(localStorage.getItem('user'));
    }
  }, []);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={1}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          variant="circle"
          src={`/static/images/avatars/`}
          to="/sup/main"
        />
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="body2"
        >
          {user.firstname} {user.lastname}
        </Typography>
        <Chip
          variant="default"
          size="small"
          label={`Perfil de acesso é ` + user.profile + `.`}
        />
      </Box>
      <Divider />
      <Box p={1}>
        <List>
          {items.map((item) => (
            (item.profile == localStorage.getItem('profile')) ? (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                color={item.color}
              />) : ('')
          ))}
        </List>
      </Box>
      <Box flexGrow={1} hidden />

      <Box
        hidden={true || localStorage.getItem('profile') === 'AST'}
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Assistência Técnica?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Monitoramento
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            href="/mon/main"
            variant="contained">
            MONITORAMENTO
          </Button>
        </Box>
      </Box>

      <Box
        hidden={true || localStorage.getItem('profile') === 'MON' || localStorage.getItem('profile') === 'MAN' || localStorage.getItem('profile') === 'AST'}
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Sair da Área de Assistência Técnica?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui Você Entra na Área de Administração do Sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            href="/adm/main"
            variant="contained">
            Administração
          </Button>
        </Box>
      </Box>

    </Box>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default NavBar;
